import React from 'react';
import useSeo from '../lib/seo';
import '../styles/home-v3.css';
import Hero from '../components/home/v3/Hero';
import Manifesto from '../components/home/v3/Manifesto';
import Services from '../components/home/v3/Services';
import Work from '../components/home/v3/Work';
import Process from '../components/home/v3/Process';
import Closing from '../components/home/v3/Closing';

function Home() {
  useSeo({
    title: 'Idealizer | Estúdio de produtos digitais',
    description: 'Estúdio de produtos digitais. Desenhamos, desenvolvemos e lançamos apps iOS e Android e plataformas web para empresas e startups, do design ao backend.',
    path: '/',
  });

  return (
    <main className="hv3">
      <Hero />
      <Manifesto />
      <Services />
      <Work />
      <Process />
      <Closing />
    </main>
  );
}

export default Home;
